import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-11 m-0 position-relative input-col-10-padding" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-1 m-0" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        id: "objectives-select-container",
        class: "custom-select-option",
        value: _ctx.selected,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('update:selected', $event.target.value))),
        required: ""
      }, [
        _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.placeholder), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (obj) => {
          return (_openBlock(), _createElementBlock("option", {
            key: obj.id,
            value: obj.id
          }, _toDisplayString(_ctx.$t(obj.name.split('.')[1])), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_3)
    ])
  ]))
}